import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'
import { faCloudDownloadAlt } from '@fortawesome/pro-regular-svg-icons/faCloudDownloadAlt'
import { Helmet } from 'react-helmet'
import axios from 'axios'
import download from 'downloadjs'
import * as yup from 'yup'

import { Heading, Group, Form, DateRange } from '@peracto/peracto-ui'
import { useConfig } from '@peracto/peracto-config'
import dayjs from 'dayjs'

const FormSubmissionsExport = () => {
    const config = useConfig()
    const API_URL = config.get('api')

    const schema = yup.object().shape({
        startDate: yup
            .date()
            .typeError('Start Date is required')
            .required('Start Date is required'),
        endDate: yup
            .date()
            .typeError('End Date is required')
            .required('End Date is required'),
    })

    // Prevent enter key submitting form
    function onKeyDown(keyEvent) {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            keyEvent.preventDefault()
        }
    }

    const handleSubmit = async values => {
        const params = new URLSearchParams({
            'submittedAt[operator]': 'between',
            'submittedAt[value][start]': dayjs(values.startDate).format('YYYY-MM-DD HH:mm:ss'),
            'submittedAt[value][end]': dayjs(values.endDate).format('YYYY-MM-DD HH:mm:ss'),
        })

        const { data } = await axios.get(
            `${API_URL}/export/form_submission.csv?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        )

        const startForName = dayjs(values.startDate).format('YYYY-MM-DD')
        const endForName = dayjs(values.endDate).format('YYYY-MM-DD')
        download(data, `form_submission_export_${startForName}_${endForName}.csv`)
    }

    return (
        <>
            <Helmet>
                <title>Export Form Submission Data | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Export Form Submission Data">
                    <div className="!ml-2 !flex !items-center">
                        <Link className="btn btn-outline-primary" to="/form-submissions">
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                            Back to Form Submissions
                        </Link>
                    </div>
                </Heading>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <Group key="form_submissions" id="form_submissions" name="Form Submissions">
                            <Form
                                values={{ startDate: null, endDate: null }}
                                schema={schema}
                                showActionPanel={false}
                                onSubmit={handleSubmit}
                                onKeyDown={onKeyDown}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <DateRange
                                            fromName="startDate"
                                            toName="endDate"
                                            fromLabel="Start Date"
                                            toLabel="End Date"
                                            required
                                        />

                                        <button
                                            className="btn btn-outline-primary"
                                            type="submit"
                                            data-testid="export-form-submissions"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCloudDownloadAlt}
                                                className="!mr-2"
                                            />
                                            Export Form Submissions
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </Group>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FormSubmissionsExport
